// ==============================|| THEME CONSTANTS ||============================== //

/**
 * Theme constants for consistent spacing, sizing, and layout
 * These values are used throughout the application for design consistency
 */

// ==============================|| SPACING ||============================== //
export const gridSpacing = 3; // Base grid spacing unit (24px)
export const spacing = {
  xs: 0.5, // 4px
  sm: 1, // 8px
  md: 2, // 16px
  lg: 3, // 24px
  xl: 4, // 32px
  xxl: 6, // 48px
};

// ==============================|| LAYOUT ||============================== //
export const headerHeight = 80; // Header height
export const footerHeight = 60; // Footer height

// ==============================|| BORDER RADIUS ||============================== //
export const borderRadius = 6; // Base border radius
export const borderRadiusScale = {
  xs: 2, // 2px
  sm: 4, // 4px
  md: 6, // 6px
  lg: 8, // 8px
  xl: 12, // 12px
  xxl: 16, // 16px
  round: "50%", // Circular
};

// ==============================|| SHADOWS ||============================== //
export const shadows = {
  xs: "0 1px 2px rgba(0, 0, 0, 0.05)",
  sm: "0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)",
  md: "0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px rgba(0, 0, 0, 0.1), 0 10px 10px rgba(0, 0, 0, 0.04)",
  xxl: "0 25px 50px rgba(0, 0, 0, 0.25)",
};

// ==============================|| BREAKPOINTS ||============================== //
export const breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
};

// ==============================|| Z-INDEX ||============================== //
export const zIndex = {
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500,
};

// ==============================|| TRANSITIONS ||============================== //
export const transitions = {
  duration: {
    shortest: 150,
    shorter: 200,
    short: 250,
    standard: 300,
    complex: 375,
    enteringScreen: 225,
    leavingScreen: 195,
  },
  easing: {
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
  },
};

// ==============================|| TYPOGRAPHY ||============================== //
export const typography = {
  fontFamily: {
    primary: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    secondary: '"Roboto Mono", "Monaco", "Consolas", monospace',
  },
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },
  fontSize: {
    xs: "0.75rem", // 12px
    sm: "0.875rem", // 14px
    md: "1rem", // 16px
    lg: "1.125rem", // 18px
    xl: "1.25rem", // 20px
    xxl: "1.5rem", // 24px
    xxxl: "2rem", // 32px
  },
  lineHeight: {
    tight: 1.25,
    normal: 1.5,
    relaxed: 1.75,
  },
};

// ==============================|| COMPONENT SIZES ||============================== //
export const componentSizes = {
  button: {
    small: { height: 32, padding: "6px 16px" },
    medium: { height: 40, padding: "8px 20px" },
    large: { height: 48, padding: "12px 24px" },
  },
  input: {
    small: { height: 32, padding: "6px 12px" },
    medium: { height: 40, padding: "8px 16px" },
    large: { height: 48, padding: "12px 20px" },
  },
  avatar: {
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 56,
  },
};
